export const nestImage = new Image();
export async function getNestImage(url) {
    return new Promise((resolve, reject) => {
        nestImage.onload = () => resolve(nestImage);
        nestImage.onerror = (err) => {
            nestImage.
            reject(err);
        };
        nestImage.src = url;
    });
}
